module.exports = __webpack_public_path__ + "assets/img/teacher (39).98873e3c.png";